import { ServiceInterface } from "@/api/Interfaces/ServiceInterface";

class ServiceEntity {
  private _id!: number;
  private _crxId!: string;
  private _clinicId!: number | string;
  private _serviceCategoryId!: number;
  private _name!: string;
  private _code!: string;
  private _price!: number | string;
  private _createdAt!: string;
  private _updatedAt!: string | null;
  private _deletedAt!: string | null;
  private _clinicRating!: number | string;
  private _ratingCount!: string;

  constructor(service: ServiceInterface) {
    this._id = service.id;
    this._crxId = service.crx_id;
    this._clinicId = service.clinic_id;
    this._serviceCategoryId = service.service_category_id;
    this._name = service.name;
    this._code = service.code;
    this._price = service.price;
    this._createdAt = service.created_at;
    this._updatedAt = service.updated_at;
    this._deletedAt = service.deleted_at;
  }

  // TODO: Validar nomenclatura padrão para métodos de
  //       exportação de entidades para a API
  public exportToApi(): ServiceInterface {
    return {
      id: this._id,
      crx_id: this._crxId,
      clinic_id: this._clinicId,
      service_category_id: this._serviceCategoryId,
      name: this._name,
      code: this._code,
      price: this._price,
      created_at: this._createdAt,
      updated_at: this._updatedAt,
      deleted_at: this._deletedAt,
      clinic_rating: this._clinicRating,
      rating_count: this._ratingCount,
    };
  }

  public get id(): number {
    return this._id;
  }

  public set id(id: number) {
    this._id = id;
  }

  public get crxId(): string {
    return this._crxId;
  }

  public set crxId(crxId: string) {
    this._crxId = crxId;
  }

  public get clinicId(): number | string {
    return this._clinicId;
  }

  public set clinicId(clinicId: number | string) {
    this._clinicId = clinicId;
  }

  public get serviceCategoryId(): number {
    return this._serviceCategoryId;
  }

  public set serviceCategoryId(serviceCategoryId: number) {
    this._serviceCategoryId = serviceCategoryId;
  }

  public get name(): string {
    return this._name;
  }

  public set name(name: string) {
    this._name = name;
  }

  public get code(): string {
    return this._code;
  }

  public set code(code: string) {
    this._code = code;
  }

  public get price(): number | string {
    return this._price;
  }

  public set price(price: number | string) {
    this._price = price;
  }

  public get createdAt(): string {
    return this._createdAt;
  }

  public set createdAt(createdAt: string) {
    this._createdAt = createdAt;
  }

  public get updatedAt(): string | null {
    return this._updatedAt;
  }

  public set updatedAt(updatedAt: string | null) {
    this._updatedAt = updatedAt;
  }

  public get deletedAt(): string | null {
    return this._deletedAt;
  }

  public set deletedAt(deletedAt: string | null) {
    this._deletedAt = deletedAt;
  }

  public get clinicRating(): number | string {
    return this._clinicRating;
  }

  public set clinicRating(clinic_rating: number | string) {
    this._clinicRating = clinic_rating;
  }

  public get ratingCount(): string {
    return this._ratingCount;
  }

  public set ratingCount(rating_count: string) {
    this._ratingCount = rating_count;
  }
}

export default ServiceEntity;
